import { Button, Grid, TextField, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import { StyledButton } from "shared/ui/Button/styles";
import ModalWindow from "shared/ui/ModalWindow/ModalWindow";
import { Controller, useFormContext, useForm } from "react-hook-form";

interface Props {
	open: boolean,
	handleClose: () => void
}

const defaultValues = {
	authorizedUserFirstName: '',
	authorizedUserLastName: '',
};


interface AuthorizedUser {
	authorizedUserFirstName: string,
	authorizedUserLastName: string,
}

const AuthorizedUserForm = ({ open, handleClose }: Props) => {
	const { setValue, getValues } = useFormContext();

	const { control, handleSubmit, setValue: setCurrentForm } = useForm({
		defaultValues: { ...defaultValues },
	});
	useEffect(() => {
		const firstName = getValues('authorizedUser.authorizedUserFirstName');
		const lastName = getValues('authorizedUser.authorizedUserLastName');

		if (firstName && lastName) {
			setCurrentForm('authorizedUserFirstName', firstName);
			setCurrentForm('authorizedUserLastName', lastName);
		}
	}, [])

	const onSubmit = () => {
		void handleSubmit((data: AuthorizedUser) => {
			setValue('authorizedUser.authorizedUserFirstName', data.authorizedUserFirstName);
			setValue('authorizedUser.authorizedUserLastName', data.authorizedUserLastName);
			handleClose();
		})()
	}

	return (
		<ModalWindow open={open} handleClose={handleClose} header={<Typography variant={"h4"} mb={0}>Add an Authorized User</Typography>}>
			<Grid container size={12} justifyContent="center" spacing={2}>
				<Grid size={{md: 6, sm: 12, xs: 12}}>
					<Controller
						name="authorizedUserFirstName"
						control={control}
						render={({ field }) =>
							<TextField
								{...field}
								fullWidth
								variant="outlined"
								label="First name"
							/>
						}
					/>
				</Grid>
				<Grid size={{md: 6, sm: 12, xs: 12}}>
					<Controller
						name="authorizedUserLastName"
						control={control}
						render={({ field }) =>
							<TextField
								{...field}
								fullWidth
								variant="outlined"
								label="Last name"
							/>
						}
					/>
				</Grid>
				<Grid container spacing={2} justifyContent="center" width={"100%"}>
					<Grid size={{md: 6, sm: 12, xs: 12}} justifyContent="center" flexDirection="column" display="flex">
						<StyledButton onClick={onSubmit} sx={{ mt: 2 }}>ADD AUTHORIZED USER</StyledButton>
						<Button onClick={handleClose} sx={{ color: "primary.light", textAlign: 'center' }}>Cancel</Button>
					</Grid>
				</Grid>
			</Grid>
		</ModalWindow>
	)
}

export default AuthorizedUserForm
